<template>
  <div class="order-info-wrapper">
    <div v-for="(item,index) in orderInfo" :key="item.id" class="order_info_border">
      <div v-if="item.order_info.length>0">
        <div class="sendLink">
          <div class="link-top" :class="item.trade_type!=1?'zj-link-top':''">
            <img :src="item.trade_type == 1?item.order_info[0].goods_image:require('@/assets/image/chat/zj_img.png')" alt="">
            <span>{{item.order_info[0].goods_name}}</span>
          </div>
          <div class="link-bottom" v-if="item.trade_type == 1">
            <div class="link-price">价格：<span>¥{{item.order_info[0].amount}}</span></div>
          </div>
        </div>
        <div class="pay-status" v-if="item.order_status==1&&!item.countDown&&$store.state.userData.user_id == item.buy_user_id">
        <!-- <div class="pay-status" v-if="item.order_status==1&&!item.countDown"> -->
          <!-- <span>
            <i class="el-icon-error"></i>
            支付已取消
          </span> -->
          <!-- <span class="pay-err">
            <i class="el-icon-error"></i>
            支付失败
          </span> -->
          <!-- <span class="pay-check">
            <i class="el-icon-more"></i>
            已支付待核对
          </span> -->
          <!-- <span class="pay-success">
            <i class="el-icon-success"></i>
            订单已支付
          </span> -->
          <div class="wait-pay">
            <el-button size="mini" @click="closeOrderPay(item,2,index)">取消支付</el-button>
            <el-button size="mini" type="primary" v-if="item.pay_type == 1" @click="closeOrderPay(item,1,index)">已支付</el-button>
            <el-button size="mini" type="primary" v-if="item.pay_type==2" @click="closeOrderPay(item,1,index)">前往支付</el-button>
            <div class="countdown">
              <count-down class="count_down" :key="item.id" :endTime="item.expire_time" :startTime="item.add_time1" @countDownChange="countDownChange($event,index)"></count-down>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="label">订单金额：</div>
          <div class="input">{{item.order_amount}}</div>
        </div>
        <div class="form-item">
          <div class="label">订单编号：</div>
          <div class="input">{{item.order_no}}</div>
        </div>
        <div class="form-item">
          <div class="label">商品编号：</div>
          <div class="input">{{item.order_info[0].unique_no}} {{ item.services == 1? '(诚心卖)' : '' }}</div>
        </div>
        <div class="form-item">
          <div class="label">合同状态：</div>
          <div class="input">{{item.contract_enum}}</div>
  <!--        <div class="input">{{getContract(item.contract)}}</div>-->
        </div>
        <div class="form-item">
          <div class="label">订单状态：</div>
          <div class="input">
            {{ item.order_status_enum }}
  <!--          {{item.order_status==1?'预交易':item.order_status==2?'交易中':item.order_status==3?'交易完成':'取消交易'}}-->
          </div>
        </div>
        <div class="form-item">
          <div class="label">交易模式：</div>
          <div class="input">
            {{ item.trade_type_enum }}
  <!--          {{item.trade_type==1?'代售':'中介'}}-->
          </div>
        </div>
        <div class="form-item">
          <div class="label">订单类型：</div>
          <div class="input">
            {{ item.order_type_enum }}
  <!--          {{item.order_type==1?'账号':item.order_type==2?'装备':item.order_type==3?'金币':item.order_type==4?'代肝':'自抽号'}}订单-->
          </div>
        </div>
        <div class="form-item">
          <div class="label">支付类型：</div>
          <div class="input">
            {{ item.pay_method_enum }}
  <!--          {{item.pay_method==1?'全款':item.pay_method==2?'垫付':item.pay_method==3?'代付分期':'普通分期'}}-->
          </div>
        </div>
        <div class="form-item" v-if="item.pay_method == 3||item.pay_method == 4">
          <div class="label">分期期数：</div>
          <div class="input">{{item.periods}}</div>
        </div>
        <div class="pay_btn_detail" v-if="item.charge_status>=1||item.refund_status>=1||item.pay_status>=1">
          <div class="pay_detail" v-if="item.charge_status>=1&&$store.state.userData.user_id == item.buy_user_id" @click="getpayDetail(item.id,1)">付款详情</div>
          <div class="pay_detail" v-if="item.pay_status>=1&&$store.state.userData.user_id == item.sale_user_id" @click="getpayDetail(item.id,2)">收款详情</div>
          <div class="refund_detail" v-if="item.refund_status>=1&&$store.state.userData.user_id == item.buy_user_id" @click="getpayDetail(item.id,3)">退款详情</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countDown from "@/components/countDown"; //引入倒计时组件
export default {
  name: 'TradingInformation',
  components: {countDown},
  props: {
    orderInfo: {
      type: Array,
      default() {
        return []
      }
    },
    closeOrderPay: {
      type: Function,
      default: null
    },
    getpayDetail: {
      type: Function,
      default: null
    },
  },
  methods: {
    countDownChange(countDown,index) {
      this.$set(this.orderInfo[index],'countDown',countDown)
      this.$emit('countDowned')
      this.$forceUpdate();
    },
    getContract(contract){
      if(contract){
        if(contract.status == 1){
          return '待签署'
        }else{
          return '已签署'
        }
      }else{
        return '未签署'
      }
    }
  },
}
</script>

<style lang="less" scoped>
.order-info-wrapper{
  .form-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding: 0px 10px;

    .label {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: LEFT;
      color: #A4ABB8;
      min-width: 70px;
    }

    .input {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #51555E;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      ::v-deep.el-input__inner {
        height: 24px;
        line-height: 24px;

        &:focus {
          border-color: var(--primary, #FF5A1F);
        }
      }
    }
  }
  .order_info_border{
    border-bottom: 5px solid var(--bg-tag, #F0EDE8);
    margin-bottom:10px;
    &:last-child{
      border: none;
      margin-bottom:0px;
    }
    .pay_btn_detail{
      margin:0 10px;
      padding: 10px 0;
      border-top: 1px solid #EFEFEF;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div{
        width: 103px;
        height: 25px;
        background: var(--bg-tag, #F0EDE8);
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        text-align: center;
        line-height: 25px;
        cursor: pointer;
      }
      .pay_detail{
        background: var(--primary, #FF5A1F);
        color: #fff;
        border: 1px solid var(--primary, #FF5A1F);
      }
      .refund_detail{
        background: #fff;
        color: var(--primary, #FF5A1F);
        border: 1px solid var(--primary, #FF5A1F);
      }
    }
    .sendLink{
      margin: 0 10px 5px;
      border-bottom: 1px solid #EFEFEF;
      padding-bottom: 10px;
      .link-top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        img{
          width: 80px;
          height: 45px;
          border-radius: 2px 2px 2px 2px;
        }
        span{
          flex: 1;
          margin-left: 10px;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
      .zj-link-top{
        img{
          width: 60px;
          height: 60px;
        }
        span{
          -webkit-line-clamp: 3;
        }
      }
      .link-bottom{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .link-price{
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          span{
            font-size: 16px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: var(--primary, #FF5A1F);
          }
        }
        .link-btn{
          width: 69px;
          height: 20px;
          line-height: 20px;
          border-radius: 4px;
          border: 1px solid var(--primary, #FF5A1F);
          font-size: 12px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: var(--primary, #FF5A1F);
          text-align: center;
          cursor: pointer;
        }
      }
    }
    .pay-status{
      border-bottom: 1px solid #EFEFEF;
      // border-left: none;
      // border-right: none;
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #CFCFCF;
      height: 35px;
      line-height: 30px;
      margin:0 10px 10px;
      span{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        i{
          font-size: 18px;
          margin-right: 3px;
        }
      }
      .pay-success{
        color: #60C75E;
      }
      .pay-err{
        color: #F56B6C;
      }
      .pay-check{
        color: var(--primary, #FF5A1F);
        i{
          background-color: var(--primary, #FF5A1F);
          border-radius: 50%;
          color: #fff
        }
      }
      .wait-pay{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .countdown{
          margin-left: 10px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
